import { z } from 'zod'

/** Whether an API requests log entry is an API-key request or an MCP tool call. */
export const REQUEST_SOURCES = ['api', 'mcp'] as const

export const requestSourceSchema = z.enum(REQUEST_SOURCES)

export type RequestSource = z.infer<typeof requestSourceSchema>

export const PRISMA_REQUEST_SOURCES = ['API', 'MCP'] as const

export type PrismaRequestSource = (typeof PRISMA_REQUEST_SOURCES)[number]

export const REQUEST_SOURCE_FROM_PRISMA = {
  API: 'api',
  MCP: 'mcp',
} as const satisfies Record<PrismaRequestSource, RequestSource>

export const REQUEST_SOURCE_TO_PRISMA = {
  api: 'API',
  mcp: 'MCP',
} as const satisfies Record<RequestSource, PrismaRequestSource>
